import { z } from 'zod'

export const LocationTypeEnum = z.enum([
  'UNSPECIFIED',
  'ATTENDEE_IN_PERSON',
  'HOST_IN_PERSON',
  'ATTENDEE_PHONE',
  'HOST_PHONE',
  'LINK',
  'CONFERENCING',
])

export type LocationTypeEnumType = z.infer<typeof LocationTypeEnum>

export const PaymentCollectionTypeEnum = z.enum([
  'UNSPECIFIED',
  'COLLECT_UPFRONT',
  'CAPTURE_DETAILS',
  'POINT_OF_SALE',
  'FREE',
])

export type PaymentCollectionTypeEnumType = z.infer<
  typeof PaymentCollectionTypeEnum
>

export const AttendanceTypeEnum = z.enum([
  'UNSPECIFIED',
  'MEETING',
  'GROUP',
  'EVENT',
])

export type AttendanceTypeEnumType = z.infer<typeof AttendanceTypeEnum>

export type NylasConfig = {
  email: string
  provider: string
  accountId: string
  tokenType: string
  accessToken: string
  conferencing: 'none' | 'meet' | 'zoom'
  integrations: Record<NylasIntegrationType, NylasAppIntegration>
  selectedCalendar: NylasCalendarInfo
  syncCalendars: NylasCalendarInfo[]
  calendarSelection: NylasCalendarInfo[]
  calendarSyncSettings: NylasCalendarSyncSettings
  primaryCalendarId: string
  lastSyncedAt?: number
  lastSyncTriggeredAt?: number
  syncing?: boolean
}

type NylasCalendarSyncSettings = {
  syncMonthsAhead: number
  syncMonthsBehind: number
}

export type NylasCalendarInfo = {
  id: string
  name: string
  location: string
  description: string
  timezone: string
  isPrimary: boolean
  isOwnedByUser: boolean
  readOnly: boolean
}

type NylasAppIntegration = {
  grantId: string
  email: string
  date: number
}

type NylasIntegrationType = 'zoom'
